import { StandardEvents } from '@shopify/events';

const THRESHOLD_CENTS = 12500;

/**
 * Updates free-shipping progress bars after cart changes.
 */
class AkFreeShippingProgress {
  /** @type {boolean} */
  #bound = false;

  init() {
    if (this.#bound) return;
    this.#bound = true;
    document.addEventListener(StandardEvents.cartLinesUpdate, this.#onCartUpdate);
    this.#refreshAll();
  }

  /** @param {CustomEvent} event */
  #onCartUpdate = () => {
    this.#refreshAll();
  };

  async #refreshAll() {
    try {
      const response = await fetch(`${Theme.routes.cart_url}.json`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (!response.ok) return;
      const cart = await response.json();
      this.#updateBars(cart.items_subtotal_price ?? 0);
    } catch {
      /* ignore */
    }
  }

  /**
   * @param {number} subtotalCents
   */
  #updateBars(subtotalCents) {
    document.querySelectorAll('[data-free-shipping-progress]').forEach((root) => {
      if (!(root instanceof HTMLElement)) return;

      const remaining = Math.max(THRESHOLD_CENTS - subtotalCents, 0);
      const percent = Math.min(Math.round((subtotalCents / THRESHOLD_CENTS) * 100), 100);
      const message = root.querySelector('[data-free-shipping-message]');
      const fill = root.querySelector('[data-free-shipping-fill]');
      const track = root.querySelector('[role="progressbar"]');

      if (message instanceof HTMLElement) {
        message.innerHTML =
          remaining === 0
            ? '<strong>Congrats! You\'ve got FREE Ground Shipping!</strong>'
            : `You're <strong>${this.#formatMoney(remaining)}</strong> away from FREE Ground Shipping!`;
      }

      if (fill instanceof HTMLElement) {
        fill.style.width = `${percent}%`;
      }

      if (track instanceof HTMLElement) {
        track.setAttribute('aria-valuenow', String(subtotalCents));
      }
    });
  }

  /** @param {number} cents */
  #formatMoney(cents) {
    if (typeof Theme?.formatMoney === 'function') {
      return Theme.formatMoney(cents);
    }
    return `$${(cents / 100).toFixed(2).replace(/\.00$/, '')}`;
  }
}

const progress = new AkFreeShippingProgress();
progress.init();
